<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3" *ngIf="currentUrl!='/feedback'"><span [translate]="'GREATER.REPORT'"> </span></div>
                <div class="breadcrumb-title pe-3" *ngIf="currentUrl=='/feedback'"><span [translate]="'GREATER.FEEDBACKS'"> </span></div> -->

                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page" *ngIf="currentUrl!='/feedback'"><span [translate]="'GREATER.REPORT'"> </span></li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="currentUrl=='/feedback'"><span [translate]="'GREATER.FEEDBACKS'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <!-- <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                        <a href="javascript:void(0)" class="btn custom-btn brand-btn" routerLink="add">
                           <span [translate]="'GREATER.LOW'"> </span>
                        </a>                 
                    </div>
                </div> -->
            </div>
            <div class="row">
                  <div class="col-3 col-md-3 pb-3">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.SEARCH_NAME_EMAIL'"> </span></label>
                    <input type="text" id="inputState" class="form-control" placeholder="{{ 'GREATER.SEARCH_NAME_EMAIL' | translate }}" [(ngModel)]='searchKey' (keyup)="p=1;getDetail(p)">
                </div>  
                   <div class="col-3 col-md-3 pb-3 pt-4">
                    <button type="button" class="btn custom-btn brand-btn2 px-4" (click)="reset()"><span [translate]="'GREATER.RESET'"> </span></button>
                </div>  
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-title d-flex align-items-center">
                                <h5 class="mb-2" *ngIf="currentUrl == '/feedback'"><span [translate]="'GREATER.FEEDBACKS'"> </span></h5>
                                <h5 class="mb-2" *ngIf="currentUrl !='/feedback'"><span [translate]="'GREATER.REPORT'"> </span></h5>
                            </div>
                            <hr>
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.TYPE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span></th>
                                        <th scope="col" *ngIf="currentUrl!='/feedback'"><span [translate]="'GREATER.REPORTED_BY'"> </span></th>
                                        <th scope="col" *ngIf="currentUrl=='/feedback'"><span [translate]="'GREATER.RATED_BY'"> </span></th>
                                        <th scope="col" ><span [translate]="'GREATER.CREATORS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.MESSAGE'"> </span></th>
                                        <th scope="col" class="d-flex"><span [translate]="'GREATER.DATE'"> </span>
                                        <span style="cursor: pointer;" class="ms-2" > <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td >{{item.typename}}</td>
                                        <td >{{item.postName}}</td>
                                        <td >{{item.createdBy}}</td>
                                        <td >{{item.creator}}</td>
                                        <td >{{item.message}}</td>
                                        <td >{{service.convertDate(item.createdAt)}}</td>                                     
                                    </tr>
                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
